// rwd
const breakpoints = {
  xs: 375,
  sm: 640,
  md: 768,
  lg: 1024,
  xl: 1280,
};

const getMaxWidth = (breakpoint) => {
  const matched = breakpoints[breakpoint];
  return matched ? `${matched}px` : breakpoint;
};

const getMinWidth = (breakpoint) => {
  const matched = breakpoints[breakpoint];
  return matched ? `${matched + 1}px` : breakpoint;
};

export const up = (breakpoint) => `@media screen and (min-width: ${getMinWidth(breakpoint)})`;

export const down = (breakpoint) => `@media screen and (max-width: ${getMaxWidth(breakpoint)})`;

export const between = (startBreakpoint, endBreakpoint) => {
  const min = getMinWidth(startBreakpoint);
  const max = getMaxWidth(endBreakpoint);
  return `@media screen and (min-width: ${min}) and (max-width: ${max})`;
};
// hover
export const hover = '@media (hover: hover) and (pointer: fine)';

const media = {
  up,
  down,
  between,
  hover,
};

export default media;
